import { render, staticRenderFns } from "./storeOrder.vue?vue&type=template&id=ccdfcae2&"
import script from "./storeOrder.vue?vue&type=script&lang=js&"
export * from "./storeOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports